<template>
  <div class="material-edit-form-container">
    <material-box
      v-if="isShow"
      ref="material_box_ref"
      :advertiser="channel_interface"
      :is-open="isShow"
      v-bind="material_box_props"
      @confirm="materialConfirm"
      @cancel="materialCancel"
      @hook:mounted="onMaterialBoxMounted"
    />
  </div>
</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';

export default {
  components: {
    'material-box': () => import('@/components/material-box'),
  },
  mixins: [data_sharing_mixin],
  props: {
    /** 素材库显示 */
    isShow: {
      type: Boolean,
      default: false,
    },
    /** 表单配置 */
    formFields: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      /** 分配表单已选项 */
      assign_selection: {},
    };
  },
  computed: {
    /** 渠道接口 */
    channel_interface() {
      const { channel_interface } = this.getInitConfig();
      return channel_interface;
    },
    /** 素材库属性 */
    material_box_props() {
      const { props } = this.formFields?.config?.material_form?.config?.material;
      return props;
    },
  },
  created() {
    const { value, props } = this.formFields?.config?.material_form?.config?.material;
    this.assign_selection = value;
    const { strategy } = this.local_sharing_data.getFormContext();
    Object.assign(props, { type: value.tab, ...strategy.getMaterialProps(this.formFields) });
  },
  methods: {
    /** 获取初始化配置 */
    getInitConfig() {
      try {
        const { getFormContext } = this.local_sharing_data;
        const form_context = getFormContext();
        const { init_ops } = form_context.config;
        return init_ops || {};
      } catch {
        return {};
      }
    },
    /** 获取分配表单已选项 */
    async getAssignSelection() {
      return Promise.resolve(this.assign_selection);
    },
    /**
     * 素材库确认
     * @param {Object[]} data 素材库选中的素材
     * @param {string} type 素材类型
     */
    materialConfirm(data, type) {
      const base_type = type === 'element_story' ? 'image' : type;
      if (data.length === 0) {
        return;
      }
      this.assign_selection[`${base_type}s`] = data;
      this.$emit('confirm');
    },
    /** 素材库取消 */
    materialCancel() {
      this.$emit('cannel');
    },
    /**
     * 初始化素材库选中数据
     * @returns {void}
     */
    initMaterialsSelection() {
      const material_box_ref = this.$refs.material_box_ref;
      const { material } = this.formFields.config.material_form.config;
      const { tab } = material.value;
      material_box_ref.select_file_arr.splice(0);
      material_box_ref.select_file_arr.push(...material.value[`${tab}s`]);
    },
    /**
     * 监听素材库挂载完成
     * @returns {void}
     */
    onMaterialBoxMounted() {
      this.initMaterialsSelection();
    },
  },
};
</script>
